export { default } from './AlternativeProductsTable'
